module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"withGift":"With Gift","isNew":"New-in"},"ar":{"withGift":"مع هدية","isNew":"جديد"}}')
  delete Component.options._Ctor
}
